module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_13_m.008a398fc6799ad8f33686980e71494b.png";